import { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence, useInView, useScroll, useTransform } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];
const INTERVAL = 3500;

const CATEGORIES = ['Todos', 'Cortes Premium', 'Res', 'Novillo', 'Arracheras', 'Empanizados', 'Cerdo', 'Productos Terminados'];

const IMG = '/img/FOTOS FEREIMA/webp/';

const PRODUCTS = [
  // ── Cortes Premium ──
  { id: 1,  name: 'Rib Eye',                  cat: 'Cortes Premium', img: IMG + 'Rib eye con etiqueta.webp' },
  { id: 2,  name: 'T-Bone',                   cat: 'Cortes Premium', img: IMG + 't bone con etiqueta.webp' },
  { id: 3,  name: 'Chuletón',                 cat: 'Cortes Premium', img: IMG + 'Chuleton con etiqueta.webp' },
  { id: 4,  name: 'Costilla Rebanada',        cat: 'Cortes Premium', img: IMG + 'Costilla rebanada con etiqueta.webp' },
  { id: 5,  name: 'Rib Eye Premium Especial', cat: 'Cortes Premium', img: IMG + 'Rib Eye Premium Especial.webp' },
  // ── Res ──
  { id: 10, name: 'Pulpa Bola',       cat: 'Res', group: 'Pulpas',           img: IMG + 'pulpa bola.webp' },
  { id: 11, name: 'Pulpa Negra',      cat: 'Res', group: 'Pulpas',           img: IMG + 'pulpa.webp' },
  { id: 12, name: 'Pulpa Blanca',     cat: 'Res', group: 'Pulpas',           img: IMG + 'pulpa(1).webp' },
  { id: 13, name: 'Top Sirloin',      cat: 'Res', group: 'Pulpas',           img: IMG + 'top sirloin.webp' },
  { id: 14, name: 'Chamberete',       cat: 'Res', group: 'Cortes',           img: null },
  { id: 15, name: 'Diezmillo',        cat: 'Res', group: 'Cortes',           img: IMG + 'diezmillo.webp' },
  { id: 16, name: 'Pecho',            cat: 'Res', group: 'Cortes',           img: null },
  { id: 17, name: 'Short Rib',        cat: 'Res', group: 'Cortes',           img: IMG + 'short rib.webp' },
  { id: 18, name: 'Paleta',           cat: 'Res', group: 'Cortes',           img: IMG + 'paleta.webp' },
  { id: 19, name: 'Pescuezo',         cat: 'Res', group: 'Cortes',           img: IMG + 'pescuezo.webp' },
  { id: 20, name: 'T-Bone',           cat: 'Res', group: 'Cortes Especiales', img: null },
  { id: 21, name: 'Chuletón',         cat: 'Res', group: 'Cortes Especiales', img: null },
  { id: 22, name: 'Costilla',         cat: 'Res', group: 'Cortes Especiales', img: null },
  { id: 23, name: 'Suadero',          cat: 'Res', group: 'Cortes Especiales', img: null },
  { id: 24, name: 'Recortes 90/10',   cat: 'Res', group: 'Recortes',         img: null },
  { id: 25, name: 'Fajita Falda',     cat: 'Res', group: 'Recortes',         img: null },
  { id: 26, name: 'Deshebrada',       cat: 'Res', group: 'Recortes',         img: null },
  { id: 27, name: 'Colas',            cat: 'Res', group: 'Varios',           img: null },
  { id: 28, name: 'Sebo Macizo',      cat: 'Res', group: 'Varios',           img: null },
  { id: 29, name: 'Hueso Perico',     cat: 'Res', group: 'Varios',           img: null },
  // ── Novillo ──
  { id: 30, name: 'Pulpa Bola',       cat: 'Novillo', group: 'Pulpas',           img: IMG + 'pulpa bola.webp' },
  { id: 31, name: 'Pulpa Negra',      cat: 'Novillo', group: 'Pulpas',           img: IMG + 'pulpa.webp' },
  { id: 32, name: 'Pulpa Blanca',     cat: 'Novillo', group: 'Pulpas',           img: IMG + 'pulpa(1).webp' },
  { id: 33, name: 'Top Sirloin',      cat: 'Novillo', group: 'Pulpas',           img: IMG + 'top sirloin.webp' },
  { id: 34, name: 'Chamberete',       cat: 'Novillo', group: 'Cortes',           img: null },
  { id: 35, name: 'Diezmillo',        cat: 'Novillo', group: 'Cortes',           img: IMG + 'diezmillo.webp' },
  { id: 36, name: 'Pecho',            cat: 'Novillo', group: 'Cortes',           img: null },
  { id: 37, name: 'Short Rib',        cat: 'Novillo', group: 'Cortes',           img: IMG + 'short rib.webp' },
  { id: 38, name: 'Paleta',           cat: 'Novillo', group: 'Cortes',           img: IMG + 'paleta.webp' },
  { id: 39, name: 'Pescuezo',         cat: 'Novillo', group: 'Cortes',           img: IMG + 'pescuezo.webp' },
  { id: 40, name: 'T-Bone',           cat: 'Novillo', group: 'Cortes Especiales', img: null },
  { id: 41, name: 'Chuletón',         cat: 'Novillo', group: 'Cortes Especiales', img: null },
  { id: 42, name: 'Costilla',         cat: 'Novillo', group: 'Cortes Especiales', img: null },
  { id: 43, name: 'Suadero',          cat: 'Novillo', group: 'Cortes Especiales', img: null },
  { id: 44, name: 'Recortes 90/10',   cat: 'Novillo', group: 'Recortes',         img: null },
  { id: 45, name: 'Fajita Falda',     cat: 'Novillo', group: 'Recortes',         img: null },
  { id: 46, name: 'Deshebrada',       cat: 'Novillo', group: 'Recortes',         img: null },
  { id: 47, name: 'Colas',            cat: 'Novillo', group: 'Varios',           img: null },
  { id: 48, name: 'Sebo Macizo',      cat: 'Novillo', group: 'Varios',           img: null },
  { id: 49, name: 'Hueso Perico',     cat: 'Novillo', group: 'Varios',           img: null },
  // ── Arracheras ──
  { id: 50, name: 'Arrachera Premium',      cat: 'Arracheras', img: IMG + 'Arrachera Premium.webp' },
  { id: 51, name: 'Arrachera Marinada',     cat: 'Arracheras', img: IMG + 'arrachera Marinada.webp' },
  { id: 52, name: 'Arrachera Gran Turismo', cat: 'Arracheras', img: IMG + 'Arrachera gran turismo.webp' },
  { id: 53, name: 'Arrachera Comercial',    cat: 'Arracheras', img: IMG + 'arrachera comercial.webp' },
  // ── Empanizados ──
  { id: 60, name: 'Hamburguesa de Pollo',    cat: 'Empanizados', img: IMG + 'EE 1.webp' },
  { id: 61, name: 'Dino Nugget',             cat: 'Empanizados', img: IMG + 'EE 2.webp' },
  { id: 62, name: 'Boneless Spicy',          cat: 'Empanizados', img: IMG + 'EE 3.webp' },
  { id: 63, name: 'Dedo de Queso Parmesano', cat: 'Empanizados', img: IMG + 'EE 4.webp' },
  { id: 64, name: 'Tender',                  cat: 'Empanizados', img: IMG + 'EE 5.webp' },
  { id: 65, name: 'Bollonete Jalapeño',      cat: 'Empanizados', img: IMG + 'EE 6.webp' },
  { id: 66, name: 'Mini Cordon Blue',        cat: 'Empanizados', img: IMG + 'EE 7.webp' },
  { id: 67, name: 'Palomita',                cat: 'Empanizados', img: IMG + 'EE 8.webp' },
  { id: 68, name: 'Dedo de Queso',           cat: 'Empanizados', img: IMG + 'EE 9.webp' },
  { id: 69, name: 'Nugget',                  cat: 'Empanizados', img: IMG + 'EE 10.webp' },
  // ── Cerdo ──
  { id: 70, name: 'Pierna SH Fresca',          cat: 'Cerdo', img: IMG + 'pierna sin hueso fresca.webp' },
  { id: 71, name: 'Pierna Promoción',          cat: 'Cerdo', img: IMG + 'Pierna promocion.webp' },
  { id: 72, name: 'Pierna Escurrida',          cat: 'Cerdo', img: IMG + 'pierna escurrida.webp' },
  { id: 73, name: 'Chamorros',                 cat: 'Cerdo', img: IMG + 'chamorro.webp' },
  { id: 74, name: 'Recorte 80/20',             cat: 'Cerdo', img: IMG + 'recorte 80-20.webp' },
  { id: 75, name: 'Grasa',                     cat: 'Cerdo', img: IMG + 'grasa de cerdo.webp' },
  { id: 76, name: 'Cuero de Pierna sin Grasa', cat: 'Cerdo', img: IMG + 'cuero de cerdo.webp' },
  { id: 77, name: 'Recorte de Cuero',          cat: 'Cerdo', img: IMG + 'recorte de cuero.webp' },
  // ── Productos Terminados ──
  { id: 80, name: 'Chorizo Argentino',           cat: 'Productos Terminados', img: IMG + 'image (34).webp' },
  { id: 81, name: 'Chorizo',                     cat: 'Productos Terminados', img: null },
  { id: 82, name: 'Chorizo Horneado',            cat: 'Productos Terminados', img: IMG + 'chorizo horneado.webp' },
  { id: 101, name: 'Chistorra',                  cat: 'Productos Terminados', img: IMG + 'image (32).webp' },
  { id: 83, name: 'Longaniza',                   cat: 'Productos Terminados', img: IMG + 'image (33).webp' },
  { id: 84, name: 'Tocino Ahumado Pieza',        cat: 'Productos Terminados', img: IMG + 'tocino ahumado.webp' },
  { id: 85, name: 'Tocino Ahumado Rebanado 1kg', cat: 'Productos Terminados', img: null },
  { id: 86, name: 'Chuleta Ahumada Barra',       cat: 'Productos Terminados', img: IMG + 'chuleta ahumada barra.webp' },
  { id: 87, name: 'Chuleta Comercial',           cat: 'Productos Terminados', img: null },
  { id: 88, name: 'Chicharrón Prensado',         cat: 'Productos Terminados', img: IMG + 'chicharron prensado.webp' },
  { id: 89, name: 'Filete Tilapia 50/50',        cat: 'Productos Terminados', img: IMG + 'filete tilapia 50.webp' },
  { id: 90, name: 'Filete Tilapia Natural 100%', cat: 'Productos Terminados', img: IMG + 'filete de pescado.webp' },
  { id: 91, name: 'Pechuga de Pollo',            cat: 'Productos Terminados', img: IMG + 'pechuga de pollo.webp' },
  { id: 92, name: 'Mole Preparado',              cat: 'Productos Terminados', img: null },
  { id: 93, name: 'Carne en Salsa Verde',        cat: 'Productos Terminados', img: null },
  { id: 94, name: 'Tamales Mole',                cat: 'Productos Terminados', img: null },
  { id: 95, name: 'Tamales Pollo',               cat: 'Productos Terminados', img: null },
  { id: 96, name: 'Tamales Rajas',               cat: 'Productos Terminados', img: null },
  { id: 97, name: 'Tamales Chicharrón',          cat: 'Productos Terminados', img: null },
  { id: 98, name: 'Tamales Dulce',               cat: 'Productos Terminados', img: null },
  { id: 99, name: 'Tamales Salsa Verde',         cat: 'Productos Terminados', img: null },
  { id: 100, name: 'Burritos',                   cat: 'Productos Terminados', img: null },
];

/* ─── Styled Components ─── */

const Section = styled.section`
  padding: 120px 2rem;
  background: #0A0A0A;
  position: relative;
  overflow: hidden;
  @media (max-width: 768px) { padding: 80px 1.25rem; }
`;

const SideImg = styled(motion.img)`
  position: absolute;
  width: 200px;
  border-radius: 14px;
  object-fit: cover;
  box-shadow: 0 12px 40px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.08);
  pointer-events: none;
  z-index: 0;
  @media (max-width: 1100px) { width: 150px; }
  @media (max-width: 768px)  { display: none; }
`;

const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const Header = styled.div`
  margin-bottom: 3rem;
  @media (max-width: 768px) { margin-bottom: 2rem; }
`;

const EyebrowWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const OrangeLine = styled.div`
  width: 32px;
  height: 2px;
  background: #F47920;
  border-radius: 1px;
`;

const Eyebrow = styled.span`
  font-size: 0.75rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #F47920;
  font-weight: 600;
`;

const Title = styled.h2`
  font-family: 'Barlow Condensed', sans-serif;
  font-size: clamp(2.4rem, 4.5vw, 3.8rem);
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.0;
  margin-bottom: 2rem;
`;

const Accent = styled.span`
  color: #F47920;
`;

const FilterWrap = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }
`;

const FilterBtn = styled.button`
  padding: 0.5rem 1.2rem;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  background: ${({ $active }) => $active ? '#F47920' : 'transparent'};
  color: ${({ $active }) => $active ? '#fff' : '#aaa'};
  border: 1px solid ${({ $active }) => $active ? '#F47920' : '#2A2A2A'};
  &:hover {
    border-color: #F47920;
    color: ${({ $active }) => $active ? '#fff' : '#F47920'};
  }
`;

/* ── Split layout ── */
const SplitLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 280px) 1fr;
  gap: 3rem;
  align-items: start;
  @media (max-width: 1024px) {
    grid-template-columns: minmax(0, 240px) 1fr;
    gap: 2rem;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

/* ── Carousel column ── */
const CarouselCol = styled.div`
  position: sticky;
  top: 100px;
  @media (max-width: 768px) { position: static; }
`;

const ImgFrame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  background: #111;
  border: 1px solid #1E1E1E;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 70% 60% at 50% 50%, rgba(244,121,32,0.06), transparent);
    pointer-events: none;
    z-index: 1;
  }
`;

const ProductImg = styled(motion.img)`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  filter: drop-shadow(0 20px 50px rgba(0,0,0,0.8));
  position: absolute;
`;

const NoImgState = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: #2A2A2A;
  position: absolute;
  svg { width: 52px; height: 52px; }
  span {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
  }
`;

const NameTag = styled(motion.div)`
  position: absolute;
  bottom: 1.25rem;
  left: 1.25rem;
  right: 1.25rem;
  z-index: 2;
  background: rgba(0,0,0,0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 12px;
  padding: 0.7rem 1rem;
`;

const NameTagCat = styled.div`
  font-size: 0.62rem;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #F47920;
  font-weight: 600;
  margin-bottom: 0.15rem;
`;

const NameTagName = styled.div`
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 1.15rem;
  font-weight: 800;
  text-transform: uppercase;
  color: #fff;
  line-height: 1.1;
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.25rem;
`;


const Dots = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const Dot = styled.button`
  width: ${({ $active }) => $active ? '20px' : '6px'};
  height: 6px;
  border-radius: 3px;
  background: ${({ $active }) => $active ? '#F47920' : '#2A2A2A'};
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { background: ${({ $active }) => $active ? '#F47920' : '#444'}; }
`;


/* ── List column ── */
const ListCol = styled.div``;

const ListMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #1A1A1A;
  margin-bottom: 0;
`;

const ListCount = styled.div`
  font-size: 0.75rem;
  color: #3A3A3A;
  letter-spacing: 0.08em;
  span { color: #F47920; font-weight: 700; }
`;

const ProductList = styled.div`
  max-height: 580px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #222 transparent;
  &::-webkit-scrollbar { width: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: #222; border-radius: 2px; }
`;

const ProductItem = styled.button`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 0.75rem;
  background: ${({ $active }) => $active ? 'rgba(244,121,32,0.07)' : 'transparent'};
  border: none;
  border-bottom: 1px solid #141414;
  cursor: ${({ $hasimg }) => $hasimg ? 'pointer' : 'default'};
  text-align: left;
  transition: background 0.2s ease;
  width: 100%;
  &:last-child { border-bottom: none; }
  &:hover { background: ${({ $hasimg, $active }) => $hasimg && !$active ? 'rgba(255,255,255,0.02)' : $active ? 'rgba(244,121,32,0.07)' : 'transparent'}; }
`;

const ItemNum = styled.div`
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: ${({ $active }) => $active ? '#F47920' : '#555'};
  min-width: 22px;
  transition: color 0.2s ease;
`;

const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const ItemName = styled.div`
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 1.1rem;
  font-weight: 800;
  text-transform: uppercase;
  color: ${({ $active }) => $active ? '#fff' : '#aaa'};
  letter-spacing: 0.02em;
  transition: color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemCatBadge = styled.div`
  font-size: 0.6rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #666;
  margin-top: 0.1rem;
`;


const GroupSep = styled.div`
  padding: 0.55rem 0.75rem 0.35rem;
  font-size: 0.6rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #666;
  font-weight: 700;
  border-bottom: 1px solid #141414;
  background: #0A0A0A;
`;

const ItemDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ $active }) => $active ? '#F47920' : 'transparent'};
  border: 1px solid ${({ $active }) => $active ? '#F47920' : '#1E1E1E'};
  flex-shrink: 0;
  transition: all 0.2s ease;
`;

/* ── CTA bar ── */
const CTABar = styled(motion.div)`
  margin-top: 3.5rem;
  background: linear-gradient(120deg, #1A0E06 0%, #1F1108 40%, #111111 100%);
  border: 1px solid rgba(244,121,32,0.3);
  border-radius: 16px;
  padding: 2rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(244,121,32,0.08), inset 0 1px 0 rgba(244,121,32,0.1);
  &::before {
    content: '';
    position: absolute;
    left: -60px;
    top: 50%;
    transform: translateY(-50%);
    width: 260px;
    height: 260px;
    background: radial-gradient(circle, rgba(244,121,32,0.18) 0%, transparent 65%);
    pointer-events: none;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 1.75rem;
  }
`;

const CTAText = styled.div`
  .title {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 1.6rem;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 0.3rem;
  }
  .sub { font-size: 0.9rem; color: #666; }
`;

const BtnGroup = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`;

const DownloadBtn = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: transparent;
  color: #fff;
  padding: 0.85rem 2rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  border: 1px solid rgba(255,255,255,0.15);
  transition: border-color 0.2s ease, background 0.2s ease;
  &:hover {
    border-color: rgba(255,255,255,0.35);
    background: rgba(255,255,255,0.05);
  }
  svg { width: 18px; height: 18px; }
  @media (max-width: 768px) { justify-content: center; }
`;

const WABTN = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: #25D366;
  color: #fff;
  padding: 0.85rem 2rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;
  &:hover { background: #1ebe5d; }
  svg { width: 20px; height: 20px; }
`;

const WA_LINK = 'https://wa.me/523951145320?text=Hola%2C%20me%20interesa%20cotizar%20sus%20productos.';

const imgVariants = {
  enter:  { opacity: 0, scale: 0.9,  y: 14 },
  center: { opacity: 1, scale: 1,    y: 0,  transition: { duration: 0.45, ease: EASE } },
  exit:   { opacity: 0, scale: 1.05, y: -8, transition: { duration: 0.28, ease: 'easeIn' } },
};

export default function Products() {
  const [active, setActive]           = useState('Todos');
  const [carouselIdx, setCarouselIdx] = useState(0);
  const [paused, setPaused]           = useState(false);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const yLeft  = useTransform(scrollYProgress, [0, 1], [90, -90]);
  const yRight = useTransform(scrollYProgress, [0, 1], [-10, 110]);

  const filtered   = active === 'Todos' ? PRODUCTS : PRODUCTS.filter(p => p.cat === active);
  const withImages = filtered.filter(p => p.img);

  const safeIdx = withImages.length > 0 ? carouselIdx % withImages.length : 0;
  const currentImgProduct = withImages[safeIdx] ?? null;

  const next = useCallback(() => {
    if (withImages.length < 2) return;
    setCarouselIdx(i => (i + 1) % withImages.length);
  }, [withImages.length]);

useEffect(() => { setCarouselIdx(0); }, [active]);

  useEffect(() => {
    if (paused || withImages.length <= 1) return;
    const t = setInterval(next, INTERVAL);
    return () => clearInterval(t);
  }, [paused, withImages.length, next]);

  const handleItemClick = (product) => {
    if (!product.img) return;
    const idx = withImages.findIndex(p => p.id === product.id);
    if (idx !== -1) { setCarouselIdx(idx); setPaused(true); }
  };

  const showDots = withImages.length > 1 && withImages.length <= 10;

  return (
    <Section id="productos" ref={ref}>
      <SideImg
        src="/img/FOTOS FEREIMA/webp/image (25).webp"
        alt=""
        style={{ left: '-70px', bottom: '0px', rotate: '-10deg', y: yLeft }}
      />
      <SideImg
        src="/img/FOTOS FEREIMA/webp/image (26).webp"
        alt=""
        style={{ right: '-40px', top: '-20px', rotate: '10deg', y: yRight }}
      />

      <Inner>
        {/* Header */}
        <Header>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
          >
            <EyebrowWrap>
              <OrangeLine />
              <Eyebrow>Catálogo</Eyebrow>
            </EyebrowWrap>
            <Title>Nuestros <Accent>Productos</Accent></Title>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.12 }}
          >
            <FilterWrap>
              {CATEGORIES.map(cat => (
                <FilterBtn
                  key={cat}
                  $active={active === cat}
                  onClick={() => { setActive(cat); setCarouselIdx(0); setPaused(false); }}
                >
                  {cat}
                </FilterBtn>
              ))}
            </FilterWrap>
          </motion.div>
        </Header>

        {/* Carousel + List */}
        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <SplitLayout>
              {/* ── Carousel ── */}
              <CarouselCol
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <ImgFrame>
                  <AnimatePresence mode="wait">
                    {currentImgProduct ? (
                      <ProductImg
                        key={`${active}-${safeIdx}`}
                        src={currentImgProduct.img}
                        alt={currentImgProduct.name}
                        variants={imgVariants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                      />
                    ) : (
                      <NoImgState
                        key="no-img"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                          <rect x="3" y="3" width="18" height="18" rx="3" ry="3"/>
                          <circle cx="8.5" cy="8.5" r="1.5"/>
                          <polyline points="21 15 16 10 5 21"/>
                        </svg>
                        <span>Sin imagen</span>
                      </NoImgState>
                    )}
                  </AnimatePresence>

                  {currentImgProduct && (
                    <AnimatePresence mode="wait">
                      <NameTag
                        key={`tag-${active}-${safeIdx}`}
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 4 }}
                        transition={{ duration: 0.3 }}
                      >
                        <NameTagCat>{currentImgProduct.cat}</NameTagCat>
                        <NameTagName>{currentImgProduct.name}</NameTagName>
                      </NameTag>
                    </AnimatePresence>
                  )}
                </ImgFrame>

                {showDots && (
                  <Controls>
                    <Dots>
                      {withImages.map((_, i) => (
                        <Dot
                          key={i}
                          $active={i === safeIdx}
                          onClick={() => { setCarouselIdx(i); setPaused(true); }}
                        />
                      ))}
                    </Dots>
                  </Controls>
                )}
              </CarouselCol>

              {/* ── Product list ── */}
              <ListCol>
                <ListMeta>
                  <ListCount>
                    <span>{filtered.length}</span> productos
                  </ListCount>
                </ListMeta>

                <ProductList>
                  {(() => {
                    const useGroups = active === 'Res' || active === 'Novillo';
                    let lastGroup = null;
                    let itemNum = 0;
                    return filtered.map((p) => {
                      itemNum++;
                      const isActive = currentImgProduct?.id === p.id;
                      const showSep = useGroups && p.group && p.group !== lastGroup;
                      if (showSep) lastGroup = p.group;
                      return (
                        <div key={p.id}>
                          {showSep && <GroupSep>{p.group}</GroupSep>}
                          <ProductItem
                            $active={isActive}
                            $hasimg={!!p.img}
                            onClick={() => handleItemClick(p)}
                          >
                            <ItemNum $active={isActive}>
                              {String(itemNum).padStart(2, '0')}
                            </ItemNum>
                            <ItemInfo>
                              <ItemName $active={isActive}>{p.name}</ItemName>
                              {active === 'Todos' && <ItemCatBadge>{p.cat}</ItemCatBadge>}
                            </ItemInfo>
                            <ItemDot $active={isActive} />
                          </ProductItem>
                        </div>
                      );
                    });
                  })()}
                </ProductList>
              </ListCol>
            </SplitLayout>
          </motion.div>
        </AnimatePresence>

        {/* CTA Bar */}
        <CTABar
          initial={{ opacity: 0, y: 24 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <CTAText>
            <div className="title">¿Necesitas un corte específico?</div>
            <div className="sub">Contáctanos por WhatsApp y te enviamos nuestro catálogo completo.</div>
          </CTAText>
          <BtnGroup>
            <DownloadBtn
              href="/catalogo/CATALOGO_FEREIMA.pdf"
              download="Catalogo_Carnes_Fereima.pdf"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Descargar Catálogo
            </DownloadBtn>
            <WABTN
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.124 1.532 5.862L0 24l6.337-1.501A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.584-.5-5.08-1.374l-.362-.214-3.763.891.936-3.667-.237-.375A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
              </svg>
              Hacer Pedido
            </WABTN>
          </BtnGroup>
        </CTABar>
      </Inner>
    </Section>
  );
}
